import { API } from 'aws-amplify';

const postInsertHistorialEstadoEtapas = (body) =>
  // esto debe apuntar a create-doc-autorization sin el body zapsign
  API.post('estrella', '/p', {
    body: {
      data: body,
      model: 'consult',
    },
  });
const postConsultCreditRenovation = (body) =>
  // esto debe apuntar a create-doc-autorization sin el body zapsign
  API.post('estrella', '/p', {
    body: {
      data: body,
      model: 'consult',
    },
  });

  const postConsultPSE = (body) =>
  // esto debe apuntar a create-doc-autorization sin el body zapsign
  API.post('estrella', '/p', {
    body: {
      data: body,
      model: 'pse',
    },
  });

const postAutomate = (body) =>
  API.post('estrella', '/p', {
    body: {
      data: body,
      model: 'automatizar',
    },
  });
const postConsultJaveriana = (body) =>
  API.post('estrella', '/p', {
    body: {
      data: body,
      model: 'javeriana',
    },
  });
const ConsultGeneral = {
  postInsertHistorialEstadoEtapas,
  postConsultCreditRenovation,
  postAutomate,
  postConsultPSE,
  postConsultJaveriana
};

export default ConsultGeneral;
